// extracted by mini-css-extract-plugin
export var btnPlay = "WordScrambleFinal-module--btn-play--S4yCE";
export var footer = "WordScrambleFinal-module--footer--rUbcd";
export var glow = "WordScrambleFinal-module--glow--tfe4N";
export var of = "WordScrambleFinal-module--of--Td16z";
export var promo = "WordScrambleFinal-module--promo--5c7vJ";
export var promoTitle = "WordScrambleFinal-module--promo-title---Nw+q";
export var score = "WordScrambleFinal-module--score--VxS1m";
export var title = "WordScrambleFinal-module--title--bFwpU";
export var wrapper = "WordScrambleFinal-module--wrapper--VCHAI";